import { render, staticRenderFns } from "./VerDetalleEnvioInformacionModal.vue?vue&type=template&id=188befd4&"
import script from "./VerDetalleEnvioInformacionModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleEnvioInformacionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('188befd4', component.options)
    } else {
      api.reload('188befd4', component.options)
    }
    module.hot.accept("./VerDetalleEnvioInformacionModal.vue?vue&type=template&id=188befd4&", function () {
      api.rerender('188befd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EnvioInformacion/VerDetalleEnvioInformacionModal.vue"
export default component.exports